import clone from "lodash/clone";
import each from "lodash/each";
import assign from "lodash/assign";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import orderBy from "lodash/orderBy";

const SAVE_WORD = "SAVE_WORD";
const DELETE_WORD = "DELETE_WORD";
const ADD_FAST_SEARCH = "ADD_FAST_SEARCH";
const REMOVE_FAST_SEARCH = "REMOVE_FAST_SEARCH";
const REMOVE_ALL_FAST_SEARCH = "REMOVE_ALL_FAST_SEARCH";

const state = {
  words: [],
  fastSearchList: []
};

function diff(date) {
  const diffTime = Math.abs(new Date() - date);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

const getters = {
  commonSearch: state => {
    let newItems = [];
    if (state.words && state.words.length > 0) {
      newItems = clone(state.words);
      each(newItems, function(item) {
        assign(item, { type: "Ricerche" });
      });
      let headerText = global.EventBus.$te("navbar.lastSearchedWords")
        ? global.EventBus.$t("navbar.lastSearchedWords")
        : "Ultime Parole Cercate";
      newItems.unshift({ header: headerText });
    }

    return newItems;
  }
};

const actions = {
  saveWord({ commit }, payload) {
    commit(SAVE_WORD, payload);
  },
  deleteWord({ commit }, payload) {
    commit(DELETE_WORD, payload);
  },
  addFastSearchWord({ commit }, payload) {
    commit(ADD_FAST_SEARCH, payload);
  },
  removeFastSearchWord({ commit }, payload) {
    commit(REMOVE_FAST_SEARCH, payload);
  },
  removeAllFastSearchWords({ commit }) {
    commit(REMOVE_ALL_FAST_SEARCH);
  }
};

const mutations = {
  [SAVE_WORD](state, value) {
    var index = findIndex(state.words, function(w) {
      return w && w.name && w.name.toLowerCase() === value.toLowerCase();
    });
    if (index !== -1) {
      // Se la parola viene trovata, aumenta il count e si aggiorna
      var count = state.words[index].counter + 1;
      state.words.splice(index, 1, {
        name: value,
        counter: count,
        timestamp: new Date().getTime()
      });
    } else {
      state.words.push({
        name: value,
        counter: 1,
        timestamp: new Date().getTime()
      });
    }
    var wordsList = filter(state.words, w => {
      var days = diff(w.timestamp);
      return days < global.config.dayWordsSaved;
    });
    state.words = orderBy(wordsList, ["counter"], ["desc"]);
  },
  [DELETE_WORD](state, item) {
    var index = findIndex(state.words, function(w) {
      return w.name.toLowerCase() === item.name.toLowerCase();
    });
    if (index !== -1) {
      // Se la parola viene trovata, la elimino
      state.words.splice(index, 1);
    }
    var wordsList = filter(state.words, w => {
      var days = diff(w.timestamp);
      return days < global.config.dayWordsSaved;
    });
    state.words = orderBy(wordsList, ["counter"], ["desc"]);
  },
  [ADD_FAST_SEARCH](state, item) {
    state.fastSearchList.push(item);
  },
  [REMOVE_FAST_SEARCH](state, item) {
    var index = findIndex(state.fastSearchList, function(w) {
      return w.toLowerCase() === item.toLowerCase();
    });
    if (index !== -1) {
      // Se la parola viene trovata, la elimino
      state.fastSearchList.splice(index, 1);
    }
  },
  [REMOVE_ALL_FAST_SEARCH](state) {
    state.fastSearchList = [];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
